export default __webpack_public_path__ + "static/spark_appstore-39e85249da2e55856c00fb0a36910970.png";